import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { useContext, useEffect } from 'react';
import { AdContext } from './AdContext';
import { AdProviders, ADUNIT_PROVIDER_SAFETY_KEY, FREESTAR_PREFIX } from './constants';
import { isSSR } from './utils';
import { BiContext } from '@wix/da-bi/pkg/BiLogger.context';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
export function useAdUnit(provider, unitId, safety, safetyState, options) {
    var _adsTargeting;
    const { DaAds } = useContext(AdContext);
    const { adsTargeting } = useContext(SessionContext);
    let className = '';
    // TODO if freestar is perma give them their own ID set
    if (provider === AdProviders.Freestar) {
        unitId = `${FREESTAR_PREFIX}${unitId}`;
    }
    // Hashtag use classnames to target and config units
    if (provider === AdProviders.Hashtag) {
        className = `htlad-${unitId}`;
    }
    var _options_targeting;
    // Add default targeting data, allow consumer to override
    options.targeting = _object_spread({}, toSlotTargeting(unitId, (_adsTargeting = adsTargeting) === null || _adsTargeting === void 0 ? void 0 : _adsTargeting.slot), (_options_targeting = options.targeting) !== null && _options_targeting !== void 0 ? _options_targeting : {});
    // Add safety to the options
    options[ADUNIT_PROVIDER_SAFETY_KEY[provider]] = safety;
    // In ssr we register on render
    if (isSSR()) {
        var _DaAds;
        (_DaAds = DaAds) === null || _DaAds === void 0 ? void 0 : _DaAds.registerUnit(provider, unitId, safety, options);
    }
    const biContext = useContext(BiContext);
    const publicSession = useContext(SessionContext);
    // On client we have side effect + kill on unmount
    useEffect(()=>{
        if (!isSSR() && safetyState === 'ready') {
            var _DaAds;
            (_DaAds = DaAds) === null || _DaAds === void 0 ? void 0 : _DaAds.registerUnit(provider, unitId, safety, options);
        }
        return ()=>{
            var _DaAds;
            (_DaAds = DaAds) === null || _DaAds === void 0 ? void 0 : _DaAds.killUnit(unitId, safety);
        };
    // only run on safety change, DaAds will handle recreation
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        safety,
        safetyState
    ]);
    // sync bi data
    useEffect(()=>{
        if (!isSSR()) {
            var _DaAds;
            (_DaAds = DaAds) === null || _DaAds === void 0 ? void 0 : _DaAds.setBiContext(biContext, publicSession);
        }
    }, [
        DaAds,
        biContext,
        publicSession
    ]);
    return {
        // suppress + danger is hack that forces current react (16+)
        // to NOT clear the inner element on hydration, this stops
        // the clobbering of the adunit on first client render.
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: ''
        },
        id: unitId,
        'data-canfs': 'yes',
        'data-safety': safety,
        advertIsOff: safety === 'off' ? 'off' : false,
        className
    };
}
/**
 * Takes the backend struct and converts it into taregting object
 */ function toSlotTargeting(unitId, slotTargeting) {
    const targeting = {};
    const filtered = slotTargeting.filter((t)=>t.unitId === unitId);
    if (filtered.length > 0) {
        for (const targetingKV of filtered){
            targeting[targetingKV.key] = targetingKV.value;
        }
    }
    return targeting;
}
